import React from "react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import styles from "./EditorSidebar.css";

export default function EditorSidebar(props) {
  return (
    <div className={styles.root}>
      <nav className={styles.nav}>
        {props.links.map(({ required, to, text }) => (
          <NavLink
            activeClassName={styles.active}
            className={classNames(styles.link, {
              [styles.error]: props.form.errors[text.toLowerCase()],
              [styles.required]: required,
            })}
            exact
            key={text}
            data-cy={text}
            to={`${props.getBaseUrl()}${to}`}
          >
            <span>{text}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

EditorSidebar.propTypes = {
  form: PropTypes.object.isRequired,
  getBaseUrl: PropTypes.func.isRequired,
  links: PropTypes.array.isRequired,
};
